import { QueryFilters } from '@tanstack/react-query'

import { ReturnSnackbars } from '@/hooks/useSnackbar/useSnackbar'
import queryClient from '@/utils/queryClient'

export const getDefaultMutations = (
  queryKey: QueryFilters,
  snackBars?: ReturnSnackbars
) => ({
  onError: () => {
    snackBars?.setErrorSnackbar?.()
  },
  onMutate: () => {
    snackBars?.setInfoSnackbar()
    return queryClient.cancelQueries(queryKey)
  },
  onSettled: () => queryClient.invalidateQueries(queryKey),
  onSuccess: () => {
    snackBars?.setSuccessSnackbar?.()
  },
})
export default getDefaultMutations

if (import.meta.vitest) {
  const { describe, expect, it, vi, beforeEach } = import.meta.vitest

  describe('getDefaultMutations', () => {
    const queryKey = { queryKey: ['example'] } as QueryFilters
    const cancelQueriesSpy = vi.spyOn(queryClient, 'cancelQueries')
    const invalidateQueriesSpy = vi.spyOn(queryClient, 'invalidateQueries')

    beforeEach(() => {
      cancelQueriesSpy.mockClear()
      invalidateQueriesSpy.mockClear()
    })

    it('wires snackbars and query client handlers', async () => {
      const snackBars = {
        setErrorSnackbar: vi.fn(),
        setInfoSnackbar: vi.fn(),
        setSuccessSnackbar: vi.fn(),
      } as ReturnSnackbars

      cancelQueriesSpy.mockResolvedValue(undefined)
      invalidateQueriesSpy.mockResolvedValue(undefined)

      const mutations = getDefaultMutations(queryKey, snackBars)

      mutations.onError()
      await mutations.onMutate()
      mutations.onSettled()
      mutations.onSuccess()

      expect(snackBars.setErrorSnackbar).toHaveBeenCalledTimes(1)
      expect(snackBars.setInfoSnackbar).toHaveBeenCalledTimes(1)
      expect(snackBars.setSuccessSnackbar).toHaveBeenCalledTimes(1)
      expect(cancelQueriesSpy).toHaveBeenCalledWith(queryKey)
      expect(invalidateQueriesSpy).toHaveBeenCalledWith(queryKey)
    })

    it('handles missing snackbars', async () => {
      cancelQueriesSpy.mockResolvedValue(undefined)

      const mutations = getDefaultMutations(queryKey)

      mutations.onError()
      await mutations.onMutate()
      mutations.onSuccess()

      expect(cancelQueriesSpy).toHaveBeenCalledWith(queryKey)
    })
  })
}
